import APICall from "../utils/APICall"

export default class SalaryServices {
    static listSalaryAccount = async (page, pageLimit, search, from, to, salaryType) => {
        return await APICall(`/api/SalaryAccountRequest/admin/list-customer-salary-accounts-request?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&salaryType=${salaryType}`, "GET")
    }
    static exportSalaryAccount = async (search, from, to, salaryType) => {
        return await APICall(`/api/SalaryAccountRequest/admin/export-salary-accounts?search=${search}&from=${from}&to=${to}&salaryType=${salaryType}`, "GET")
    }
    static actionSalaryAccount = async (payload) => {
        return await APICall(`/api/SalaryAccountRequest/admin/action-salary-accounts`, "POST", payload)
    }
    static viewSalary = async (salaryAccountId) => {
        return await APICall(`/api/SalaryAccountRequest/admin/view-customer-salary-account?salaryAccountId=${salaryAccountId}`, "GET")
    }
   
}